import React, { Component, useState, Fragment, useEffect, useMemo, useRef } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, Modal, Grid, Box, TextField, FormControl, InputLabel, Drawer, Menu, Paper } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AccordionSummary from '@mui/material/AccordionSummary';
import SettingsIcon from '@mui/icons-material/Settings';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Popover from '@mui/material/Popover';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import TrackChangesOutlinedIcon from '@material-ui/icons/TrackChangesOutlined';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';
import { pt } from 'date-fns/locale';

const BrandTargetForm = () => {
    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const [allIndia, setAllIndia] = useState(false);
    // @@@@@@@@@@@@@@ start 
    const [openModal, setOpenModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const validateTargetForm = () => {
        if (!selectedBrand || !selectedBrand.id) {
            return {
                valid: false,
                message: "Please Select Brand",
            };
        }
        if (
            totalTarget === "" ||
            totalTarget === null ||
            Number(totalTarget) <= 0
        ) {
            return {
                valid: false,
                message: "Please Enter Valid Total Target",
            };
        }
        if (!fromDate) {
            return {
                valid: false,
                message: "Please Select Start Date",
            };
        }
        if (!toDate) {
            return {
                valid: false,
                message: "Please Select End Date",
            };
        }
        if (new Date(fromDate) > new Date(toDate)) {
            return {
                valid: false,
                message: "Start Date cannot be greater than End Date",
            };
        }
        if (!stateTargetList || stateTargetList.length === 0) {
            return {
                valid: false,
                message: "Please Add State Target",
            };
        }
        const selectedStateIds = [];
        let totalStateTarget = 0;
        for (let i = 0; i < stateTargetList.length; i++) {
            const row = stateTargetList[i];

            if (!row.state || !row.state.id) {
                return {
                    valid: false,
                    message: `Please Select State in Row ${i + 1}`,
                };
            }
            if (selectedStateIds.includes(row.state.id)) {
                return {
                    valid: false,
                    message: `${row.state.title} selected multiple times`,
                };
            }
            selectedStateIds.push(row.state.id);
            if (
                row.target === "" ||
                row.target === null ||
                Number(row.target) <= 0
            ) {
                return {
                    valid: false,
                    message: `Please Enter Valid State Target in Row ${i + 1}`,
                };
            }
            totalStateTarget += Number(row.target);
        }
        if (totalStateTarget !== Number(totalTarget)) {
            return {
                valid: false,
                message: `Total State Target (${totalStateTarget}) must equal Total Target (${totalTarget})`,
            };
        }
        return {
            valid: true,
        };
    };
    const handleEditTarget = async (id) => {
        try {
            setIsLoading(true);
            const config = {
                headers: {
                    Authorization: token,
                    adminId,
                    userLevel,
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            };
            const res = await axios.post(
                `${API_BASE_URL}/api/admin/v2/edit-target-view/${id}`,
                {},
                config
            );
            const target = res.data.data;
            setEditId(target.id);
            setIsEdit(true);
            setSelectedBrand(
                brandOptions.find(
                    item => item.id === target.brand_id
                )
            );
            setTotalTarget(target.total_target);
            setFromDate(target.start_date);
            setToDate(target.end_date);
            setAllIndia(target.all_india === 1);
            setStateTargetList(
                target.state_target.map(item => ({
                    state: stateOptions.find(
                        s => s.id === item.state_id
                    ),
                    target: item.target
                }))
            );
            setOpenModal(true);
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    };
    const handleUpdateTarget = async () => {
        try {
            setIsLoading(true);
            const validation = validateTargetForm();
            if (!validation.valid) {
                setSnackbarMessage(validation.message);
                setSnackbarOpen(true);
                return;
            }
            const payload = {
                id: editId,
                brand_id: selectedBrand.id,
                total_target: Number(totalTarget),
                start_date: fromDate,
                end_date: toDate,
                state_target: stateTargetList.map(item => ({
                    state_id: item.state.id,
                    target: Number(item.target)
                }))
            };
            const config = {
                headers: {
                    Authorization: token,
                    adminId,
                    userLevel,
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            };
            await axios.post(
                `${API_BASE_URL}/api/admin/v2/update-target/${editId}`,
                payload,
                config
            );
            setSnackbarMessage("Target Updated Successfully");
            setSnackbarOpen(true);
            setOpenModal(false);
            fetchData();
        } catch (err) {
            setSnackbarMessage(
                err.response?.data?.message || "Update Failed"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };
    // @@@@@@@@@@@@@@ end
    const today = new Date();
    const monthStart = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
    );
    const monthEnd = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
    );
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const [fromDate, setFromDate] = useState(
        formatDate(monthStart)
    );
    const [toDate, setToDate] = useState(
        formatDate(monthEnd)
    );
    const [productBrand, setProductBrand] = useState([]);
    const [enquirySource, setEnquirySource] = useState([]);
    const [selectedExecutive, setSelectedExecutive] = useState(null);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [selectedState, setSelectedState] = useState();
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [excutiveassign, setExcutiveAssign] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [updatedData, setUpdatedData] = useState({
        status: '',
    });
    const [brands, setBrands] = useState([]);
    const [selectedBrandId, setSelectedBrandId] = useState('');
    const [selectedModelId, setSelectedModelId] = useState('');
    const [tractorModels, setTractorModels] = useState([]);
    const [doubleClickedRow, setDoubleClickedRow] = useState(null);
    const [message, setMessage] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [campaignOptions, setCampaignOptions] = useState([]);
    const [stateTargetList, setStateTargetList] = useState([
        {
            state: null,
            target: ""
        }
    ]);
    const [totalTarget, setTotalTarget] = useState("");
    useEffect(() => {
        const fetchCampaignList = async () => {
            try {
                const config = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(
                    `${API_BASE_URL}/api/admin/v2/campaign-list`,
                    {},
                    config
                );
                const campaignData =
                    response?.data?.data?.unassigned_list?.map((item, index) => ({
                        id: index + 1,
                        title: item.campaign_id,
                    })) || [];
                setCampaignOptions(campaignData);
                console.log("Campaign List:", campaignData);
            } catch (error) {
                console.error("Error fetching campaign list:", error);
            }
        };
        fetchCampaignList();
    }, []);

    useEffect(() => {
        fetch(`${API_BASE_URL}/mobile/api/v1/new-tractor/brand/model`)
            .then(response => response.json())
            .then(data => {
                setBrands(data.data);
            })
            .catch(error => {
                console.error('Error fetching brands:', error);
            });
    }, []);
    const handleBrandChangeBrandselect = (event) => {
        const brandId = event.target.value;
        setSelectedBrandId(brandId);
        const selectedBrand = brands.find(brand => brand.brand_id === parseInt(brandId));
        if (selectedBrand) {
            setTractorModels(selectedBrand.tractor_models);
            setSelectedModelId('');
        }
    };
    const handleModelChange = (event) => {
        const modelId = event.target.value;
        setSelectedModelId(modelId);
    };
    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));
                setBrandOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);
    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_id,
                    title: item.state_name,
                }));
                setStateOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatastate();
    }, []);

    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
                const filteredData = response.data.data.filter(item => item.status === 1);
                const mappedData = filteredData.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));
                const optionsWithNull = [
                    ...mappedData,
                ];
                setExecutiveOptions(optionsWithNull);
            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };
        fetchDatalist();
    }, []);

    const handleExecutiveChange = (event) => {
        const selectedId = event.target.value;
        setSelectedExecutive(selectedId);
    };
    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };
    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };
    const fetchData = async () => {
        setError(null);
        setIsLoading(true);
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/get-target-list`,
                {
                    pagination: perPage,
                    page: page + 1,
                    brand_id: selectedBrand?.id || "",
                },
                config
            );
            const targetList = response?.data?.data?.data || [];
            const mappedData = targetList.map((item, index) => ({
                id: (page * perPage) + index + 1,
                target_id: item.id,
                brand_name: item.brand?.brand_name || "-",
                total_target: item.total_target || 0,
                start_date: item.start_date || "-",
                end_date: item.end_date || "-",
                status: item.is_active === 1 ? "Active" : "Inactive",
                state_targets: item.state_targets?.length
                    ? item.state_targets
                        .map(
                            state =>
                                `${state.state?.state_name} (${state.target})`
                        )
                        .join(", ")
                    : "-",

                created_at: new Date(item.created_at).toLocaleString("en-IN"),
            }));
            setData(mappedData);
            setTotalCount(response?.data?.data?.total || 0);
        } catch (error) {
            console.error("Error fetching target list:", error);
            setError(
                error?.response?.data?.message ||
                "Failed to fetch target list"
            );
        } finally {
            setIsLoading(false);
        }
    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };
    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };
    const handlePrevious = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };
    const handleNext = () => {
        setPage(page + 1);
    };
    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        setSelectedRows([]);
        fetchData(perPage, page, search, totalCount, selectedExecutive, selectedBrand, selectedState, enquirySource);
    };
    const clearForm = () => {
        window.location.reload();
        setSearch('');
    };
    const handleSelectAllCheck = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(Array.from({ length: data.length }, (_, i) => i));
        }
    };
    const handleRowSelect = (rowIndex) => {
        if (selectedRows.includes(rowIndex)) {
            setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
        } else {
            setSelectedRows([...selectedRows, rowIndex]);
        }
    };
    const handleRowsSelect = (currentRowsSelected, allRowsSelected) => {
        setSelectedRows(allRowsSelected.map((row) => row.index));
    };
    const handleRowsDelete = (rowsDeleted) => {
        console.log('Rows to be deleted:', rowsDeleted);
    };
    const handleSubmits = async () => {
        try {
            setIsLoading(true);
            const validation = validateTargetForm();
            if (!validation.valid) {
                setSnackbarMessage(validation.message);
                setSnackbarOpen(true);
                return;
            }
            const payload = {
                brand_id: selectedBrand.id,
                total_target: Number(totalTarget),
                start_date: fromDate,
                end_date: toDate,
                all_india: allIndia ? 1 : 0,
                state_target: stateTargetList.map((item) => ({
                    state_id: item.state.id,
                    target: Number(item.target),
                })),
            };
            console.log("Store Target Payload =>", payload);
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/store-target`,
                payload,
                config
            );
            setSnackbarMessage(
                response?.data?.message || "Target Created Successfully"
            );
            setSnackbarOpen(true);
            setSelectedBrand(null);
            setTotalTarget("");
            setStateTargetList([
                {
                    state: null,
                    target: "",
                },
            ]);
            fetchData();
        } catch (error) {
            console.error("Store Target Error:", error);
            setSnackbarMessage(
                error?.response?.data?.message ||
                "Failed to Create Target"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };
    const handleExecutiveChanges = (e) => {
        setExcutiveAssign(e.target.value);
    };
    const columns = [
        {
            name: "id",
            label: "S/N",
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: "brand_name",
            label: "Brand Name",
            options: {
                filter: true,
                customBodyRender: (value) => (
                    <button
                        className={classes.brandstrip}
                        style={{
                            backgroundColor: getColor(value),
                            color: getColorfont(value),
                            width: "100%",
                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "total_target",
            label: "Total Target",
            options: {
                filter: false,
            },
        },
        {
            name: "start_date",
            label: "Start Date",
            options: {
                filter: false,
            },
        },
        {
            name: "end_date",
            label: "End Date",
            options: {
                filter: false,
            },
        },
        {
            name: "state_targets",
            label: "State Targets",
            options: {
                filter: false,
                customBodyRender: (value) => (
                    <div
                        style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            maxWidth: "300px",
                        }}
                    >
                        {value}
                    </div>
                ),
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                customBodyRender: (value) => (
                    <span
                        style={{
                            color: value === "Active" ? "green" : "red",
                            fontWeight: 600,
                        }}
                    >
                        {value}
                    </span>
                ),
            },
        },
        {
            name: "created_at",
            label: "Created At",
            options: {
                filter: false,
            },
        },
        {
            name: "action",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    const row = data[dataIndex];
                    return (
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            startIcon={<EditIcon />}
                            onClick={() => handleEditTarget(row.target_id)}
                        >
                            Edit
                        </Button>
                    );
                }
            }
        }
    ];
    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );
    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };
    const handleRowClick = (rowIndex) => {
        const isSelected = selectedRows.includes(rowIndex);
        if (isSelected) {
            setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
        } else {
            setSelectedRows([...selectedRows, rowIndex]);
        }
    };
    const options = {
        onRowClick: (rowData, rowMeta) => handleRowClick(rowMeta.dataIndex),
        selectableRows: 'multiple',
        onRowsSelect: handleRowsSelect,
        onRowsDelete: handleRowsDelete,
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },
        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),
        setRowProps: (row, dataIndex, rowIndex) => ({
            style: {
                backgroundColor: doubleClickedRow === rowIndex ? '#D2DE32' : selectedRows.includes(dataIndex) ? '#D2DE32' : 'inherit',
            },
            onDoubleClick: () => handleRowDoubleClick(row, rowIndex),
        }),

    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    const handleRowDoubleClick = (row, rowIndex) => {
        console.log("Row double-clicked:", row);
        console.log("Row index:", rowIndex);
        const updatedSelectedRows = [...selectedRows];
        const rowIndexInSelectedRows = updatedSelectedRows.indexOf(rowIndex);
        if (rowIndexInSelectedRows === -1) {
            updatedSelectedRows.push(rowIndex);
        } else {
            updatedSelectedRows.splice(rowIndexInSelectedRows, 1);
        }
        setSelectedRows(updatedSelectedRows);
    };
    const handleUpdateClick = (event, rowIndex) => {
        setSelectedUser(data[rowIndex]);
        setUpdatedData({
            status: data[rowIndex].status,
            email: data[rowIndex].email,
        });
        setPopoverAnchor(event.currentTarget);
    };
    const handleClosePopover = () => {
        setPopoverAnchor(null);
    };
    const handleInputChange = (e) => {
        setUpdatedData({
            ...updatedData,
            [e.target.name]: e.target.value,
        });
        if (e.target.name === 'status') {
            handleFormSubmit();
        }
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const updatedUserData = { ...selectedUser, ...updatedData };
            const response = await axios.post(`${API_BASE_URL}/api/admin/v2/bulk-status-change/${selectedUser.id}`, updatedUserData);
            console.log('User data updated:', updatedUserData);
            setMessage(response.data.message);
            handleClosePopover();
        } catch (error) {
            console.error('Error updating user data:', error);
        }
    };
    const statusOptions = ['Status', 'Busy', 'Not Connected', 'Switched Off', 'Wrong Number'];
    const handleSelectedRowsCount = () => {
        return selectedRows.length;
    };
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    const handleStateTargetChange = (index, field, value) => {
        const updatedList = [...stateTargetList];
        updatedList[index][field] = value;
        setStateTargetList(updatedList);
    };
    const handleAddState = () => {
        setStateTargetList([
            ...stateTargetList,
            {
                state: null,
                target: ""
            }
        ]);
    };
    const handleRemoveState = (index) => {
        const updatedList = stateTargetList.filter((_, i) => i !== index);
        setStateTargetList(updatedList);
    };
    const totalStateTarget = stateTargetList.reduce(
        (sum, item) => sum + (Number(item.target) || 0),
        0
    );
    const handleAllIndiaChange = (checked) => {
        setAllIndia(checked);
        if (checked) {
            const total = Number(totalTarget) || 0;
            if (stateOptions.length === 0) return;
            const stateCount = stateOptions.length;
            const baseTarget = Math.floor(total / stateCount);
            const remainder = total % stateCount;
            const autoStateList = stateOptions.map((state, index) => ({
                state,
                target:
                    index === 0
                        ? baseTarget + remainder
                        : baseTarget,
            }));
            setStateTargetList(autoStateList);
        } else {
            setStateTargetList([
                {
                    state: null,
                    target: "",
                },
            ]);
        }
    };

    const source = axios.CancelToken.source();
    const sourceRef = useRef(null);
    useEffect(() => {
        sourceRef.current = axios.CancelToken.source();
        fetchData(
            perPage,
            page,
            search,
            totalCount,
            selectedExecutive,
            selectedBrand,
            selectedState,
            enquirySource,
            sourceRef.current
        );
        return () => {
            sourceRef.current.cancel('Request canceled by cleanup');
        };
    }, [perPage, page,], 2000);

    return (
        <>
            {message && <p
                className={classes.message}
            >{message}</p>}
            <div>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                >
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>
            <Box sx={{ width: '100%' }}>
                <Grid container>
                    <Grid item xs={6} style={{ marginTop: "8px" }}>
                        <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                            Brand Target
                        </Typography>
                    </Grid>
                </Grid>
                <hr className={classes.horizontalline} />
            </Box>
            <div className={classes.root}>
                <div className={classes.root}  >
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={3} lg={3} >
                            <Autocomplete
                                classes={{
                                    option: classes.autocompleteoption,
                                }}
                                options={brandOptions}
                                getOptionLabel={(option) => option.title}
                                renderInput={(params) => (
                                    <TextField {...params} placeholder='Select brand' variant="outlined" />
                                )}
                                value={selectedBrand}
                                onChange={handleBrandChange}
                                disableCloseOnSelect
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionSelected={(option, value) => option.id === value.id}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>

                                        {option.title}
                                    </li>
                                )}
                            />
                        </Grid>

                        <Grid item xs={4} sm={2} lg={2} >
                            <input
                                className={classes.inputform}
                                type="number"
                                min="1"
                                placeholder="Target"
                                value={totalTarget}
                                // onChange={(e) => setTotalTarget(e.target.value)}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setTotalTarget(value);

                                    if (allIndia) {
                                        const total = Number(value) || 0;
                                        const stateCount = stateOptions.length;
                                        if (stateCount > 0) {
                                            const baseTarget = Math.floor(total / stateCount);
                                            const remainder = total % stateCount;
                                            const autoStateList = stateOptions.map((state, index) => ({
                                                state,
                                                target:
                                                    index === 0
                                                        ? baseTarget + remainder
                                                        : baseTarget,
                                            }));
                                            setStateTargetList(autoStateList);
                                        }
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={2} >
                            <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={2}>
                            <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                        </Grid>
                        <Grid
                            item
                            xs={4}
                            sm={2}
                            lg={2}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                marginTop: "5px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "6px",
                                }}
                            >
                                <Checkbox
                                    checked={allIndia}
                                    color="primary"
                                    onChange={(e) => handleAllIndiaChange(e.target.checked)}
                                    style={{ padding: "4px" }}
                                />
                                <Typography
                                    style={{
                                        fontWeight: 600,
                                        color: "#1976d2",
                                        fontSize: "14px",
                                        lineHeight: 1,
                                        marginTop: "2px",
                                    }}
                                >
                                    All India
                                </Typography>
                            </div>
                        </Grid>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                tableLayout: "fixed",
                                marginTop: "15px",
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={{
                                        border: "1px solid #ddd",
                                        padding: "10px",
                                        textAlign: "left",
                                        width: "45%",
                                    }}

                                    >State</th>
                                    <th style={{
                                        border: "1px solid #ddd",
                                        padding: "10px",
                                        textAlign: "left",
                                        width: "45%",
                                    }}>Target</th>
                                    <th
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "10px",
                                            textAlign: "left",
                                            width: "10%",
                                        }}
                                    >
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {stateTargetList.map((item, index) => (
                                    <tr key={index}>
                                        <td
                                            style={{
                                                border: "1px solid #e0e0e0",
                                                padding: "8px",
                                                width: "45%",
                                            }}
                                        >
                                            <Autocomplete
                                                disabled={allIndia}
                                                classes={{
                                                    option: classes.autocompleteoption,
                                                }}
                                                options={stateOptions}
                                                getOptionLabel={(option) => option.title || ""}
                                                value={item.state}
                                                onChange={(event, newValue) =>
                                                    handleStateTargetChange(index, "state", newValue)
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select State"
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    />
                                                )}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.id === value?.id
                                                }
                                            />
                                        </td>
                                        <td
                                            style={{
                                                border: "1px solid #e0e0e0",
                                                padding: "8px",
                                                width: "45%",
                                            }}
                                        >
                                            <input
                                                disabled={allIndia}
                                                className={classes.inputform}
                                                type="number"
                                                min="1"
                                                placeholder="State Target"
                                                value={item.target}
                                                onChange={(e) =>
                                                    handleStateTargetChange(
                                                        index,
                                                        "target",
                                                        e.target.value
                                                    )
                                                }
                                                style={{
                                                    width: "100%",
                                                    height: "40px",
                                                    padding: "0 12px",
                                                    boxSizing: "border-box",
                                                }}
                                            />
                                        </td>
                                        <td
                                            style={{
                                                border: "1px solid #e0e0e0",
                                                padding: "8px",
                                                width: "10%",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 10,
                                                    minWidth: 100,
                                                }}
                                            >
                                                {index === stateTargetList.length - 1 && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={handleAddState}
                                                        style={{
                                                            width: 30,
                                                            height: 30,
                                                            borderRadius: "50%",
                                                            background: "linear-gradient(135deg,#52c41a,#389e0d)",
                                                            color: "#fff",
                                                            boxShadow: "0 2px 8px rgba(56,158,13,.35)",
                                                        }}
                                                    >
                                                        <AddBoxOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                                {stateTargetList.length > 1 && (
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleRemoveState(index)}
                                                        style={{
                                                            width: 30,
                                                            height: 30,
                                                            borderRadius: "50%",
                                                            background: "linear-gradient(135deg,#ff4d4f,#cf1322)",
                                                            color: "#fff",
                                                            boxShadow: "0 2px 8px rgba(207,19,34,.35)",
                                                        }}
                                                    >
                                                        <DeleteOutlineOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr
                                    style={{
                                        background: "#f5f5f5",
                                        fontWeight: "bold",
                                    }}
                                >
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "12px",
                                            textAlign: "right",
                                            fontSize: "15px",
                                        }}
                                    >
                                        Total Target
                                    </td>
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "12px",
                                            fontSize: "16px",
                                            color: "#0d6efd",
                                            fontWeight: 700,
                                        }}
                                    >
                                        {totalStateTarget}
                                    </td>
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "12px",
                                            textAlign: "center",
                                        }}
                                    >
                                        {stateTargetList.length} Rows
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            lg={12}
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                            }}
                        >
                            <Button
                                onClick={handleSubmits}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined"
                                startIcon={<TrackChangesOutlinedIcon />}
                            >
                                Brand Target
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <br />
            <MuiThemeProvider theme={customTheme()}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }
                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />

                        ) : (
                            <Typography className={classes.tabletittle} >
                                Brand Target
                            </Typography>
                        )
                    } data={memoizedData}
                    columns={columns}
                    options={options}
                />
            </MuiThemeProvider>
            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>
                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={brandOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select Brand' variant="outlined" />
                                        )}
                                        value={selectedBrand}
                                        onChange={handleBrandChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                {option.title}
                                            </li>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >

            <Popover
                open={Boolean(popoverAnchor)}
                anchorEl={popoverAnchor}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {selectedUser && (
                    <div>
                        <form onSubmit={handleFormSubmit}>
                            <div style={{ display: "flex", padding: "10px" }}>
                                <label>
                                    <select
                                        style={{ width: "100px", marginRight: "10px" }}
                                        className={classes.selectform}
                                        name="status"
                                        value={updatedData.status}
                                        onChange={handleInputChange}
                                    >
                                        {statusOptions.map((status) => (
                                            <option key={status} value={status}>
                                                {status}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                                <Button
                                    style={{ marginRight: "10px" }}
                                    className={classes.buttonform}
                                    type="submit">Submit</Button>
                            </div>
                        </form>
                    </div>
                )}
            </Popover>
            <Modal
                open={openModal}
                onClose={() => {
                    setOpenModal(false);
                    setIsEdit(false);
                }}
            >
                <Box
                    sx={{
                        width: "90%",
                        maxWidth: 1100,
                        maxHeight: "90vh",
                        overflowY: "auto",
                        bgcolor: "#fff",
                        p: 3,
                        mx: "auto",
                        mt: 4,
                        borderRadius: 2
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Update Brand Target
                    </Typography>
                    <div className={classes.root}>
                        <div className={classes.root}  >
                            <Grid container spacing={1}>
                                <Grid item xs={4} sm={3} lg={3} >
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={brandOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select brand' variant="outlined" />
                                        )}
                                        value={selectedBrand}
                                        onChange={handleBrandChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>

                                                {option.title}
                                            </li>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={2} >
                                    <input
                                        className={classes.inputform}
                                        type="number"
                                        min="1"
                                        placeholder="Target"
                                        value={totalTarget}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setTotalTarget(value);
                                            if (allIndia) {
                                                const total = Number(value) || 0;
                                                const stateCount = stateOptions.length;
                                                if (stateCount > 0) {
                                                    const baseTarget = Math.floor(total / stateCount);
                                                    const remainder = total % stateCount;
                                                    const autoStateList = stateOptions.map((state, index) => ({
                                                        state,
                                                        target:
                                                            index === 0
                                                                ? baseTarget + remainder
                                                                : baseTarget,
                                                    }));
                                                    setStateTargetList(autoStateList);
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={2} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={2}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    sm={2}
                                    lg={2}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        marginTop: "5px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "6px",
                                        }}
                                    >
                                        <Checkbox
                                            checked={allIndia}
                                            color="primary"
                                            onChange={(e) => handleAllIndiaChange(e.target.checked)}
                                            style={{ padding: "4px" }}
                                        />
                                        <Typography
                                            style={{
                                                fontWeight: 600,
                                                color: "#1976d2",
                                                fontSize: "14px",
                                                lineHeight: 1,
                                                marginTop: "2px",
                                            }}
                                        >
                                            All India
                                        </Typography>
                                    </div>
                                </Grid>
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        tableLayout: "fixed",
                                        marginTop: "15px",
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{
                                                border: "1px solid #ddd",
                                                padding: "10px",
                                                textAlign: "left",
                                                width: "45%",
                                            }}

                                            >State</th>
                                            <th style={{
                                                border: "1px solid #ddd",
                                                padding: "10px",
                                                textAlign: "left",
                                                width: "45%",
                                            }}>Target</th>
                                            <th
                                                style={{
                                                    border: "1px solid #ddd",
                                                    padding: "10px",
                                                    textAlign: "left",
                                                    width: "10%",
                                                }}
                                            >
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stateTargetList.map((item, index) => (
                                            <tr key={index}>
                                                <td
                                                    style={{
                                                        border: "1px solid #e0e0e0",
                                                        padding: "8px",
                                                        width: "45%",
                                                    }}
                                                >
                                                    <Autocomplete
                                                        disabled={allIndia}
                                                        classes={{
                                                            option: classes.autocompleteoption,
                                                        }}
                                                        options={stateOptions}
                                                        getOptionLabel={(option) => option.title || ""}
                                                        value={item.state}
                                                        onChange={(event, newValue) =>
                                                            handleStateTargetChange(index, "state", newValue)
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select State"
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) =>
                                                            option.id === value?.id
                                                        }
                                                    />
                                                </td>
                                                <td
                                                    style={{
                                                        border: "1px solid #e0e0e0",
                                                        padding: "8px",
                                                        width: "45%",
                                                    }}
                                                >
                                                    <input
                                                        disabled={allIndia}
                                                        className={classes.inputform}
                                                        type="number"
                                                        min="1"
                                                        placeholder="State Target"
                                                        value={item.target}
                                                        onChange={(e) =>
                                                            handleStateTargetChange(
                                                                index,
                                                                "target",
                                                                e.target.value
                                                            )
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            height: "40px",
                                                            padding: "0 12px",
                                                            boxSizing: "border-box",
                                                        }}
                                                    />
                                                </td>
                                                <td
                                                    style={{
                                                        border: "1px solid #e0e0e0",
                                                        padding: "8px",
                                                        width: "10%",
                                                        textAlign: "center",
                                                        verticalAlign: "middle",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: 10,
                                                            minWidth: 100,
                                                        }}
                                                    >
                                                        {index === stateTargetList.length - 1 && (
                                                            <IconButton
                                                                size="small"
                                                                onClick={handleAddState}
                                                                style={{
                                                                    width: 30,
                                                                    height: 30,
                                                                    borderRadius: "50%",
                                                                    background: "linear-gradient(135deg,#52c41a,#389e0d)",
                                                                    color: "#fff",
                                                                    boxShadow: "0 2px 8px rgba(56,158,13,.35)",
                                                                }}
                                                            >
                                                                <AddBoxOutlinedIcon fontSize="small" />
                                                            </IconButton>
                                                        )}
                                                        {stateTargetList.length > 1 && (
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleRemoveState(index)}
                                                                style={{
                                                                    width: 30,
                                                                    height: 30,
                                                                    borderRadius: "50%",
                                                                    background: "linear-gradient(135deg,#ff4d4f,#cf1322)",
                                                                    color: "#fff",
                                                                    boxShadow: "0 2px 8px rgba(207,19,34,.35)",
                                                                }}
                                                            >
                                                                <DeleteOutlineOutlinedIcon fontSize="small" />
                                                            </IconButton>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr
                                            style={{
                                                background: "#f5f5f5",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            <td
                                                style={{
                                                    border: "1px solid #ddd",
                                                    padding: "12px",
                                                    textAlign: "right",
                                                    fontSize: "15px",
                                                }}
                                            >
                                                Total Target
                                            </td>
                                            <td
                                                style={{
                                                    border: "1px solid #ddd",
                                                    padding: "12px",
                                                    fontSize: "16px",
                                                    color: "#0d6efd",
                                                    fontWeight: 700,
                                                }}
                                            >
                                                {totalStateTarget}
                                            </td>
                                            <td
                                                style={{
                                                    border: "1px solid #ddd",
                                                    padding: "12px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {stateTargetList.length} Rows
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </Grid>
                        </div>
                    </div>
                    <Grid
                        container
                        justifyContent="flex-end"
                        spacing={2}
                        sx={{ mt: 2, }}
                        style={{ marginTop: "5px" }}

                    >
                        <Grid item>
                            <Button
                                color="primary"
                                onClick={handleUpdateTarget}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined"
                                startIcon={<TrackChangesOutlinedIcon />}
                            >
                                Update Target
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                onClick={() => setOpenModal(false)}
                            >
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    );
};

export default BrandTargetForm;